<template>
  <div>
    <!-- 팝업 배너 -->
    <transition name="fade">
      <div v-if="showPopup" class="popup-banner-overlay" @click="closePopup">
        <div class="popup-banner-container" @click.stop>
          <!-- 닫기 버튼 -->
          <button class="close-btn" @click="closePopup" title="3일간 보지 않기">
            <i class="fa fa-times"></i>
          </button>

          <!-- 배너 이미지 -->
          <div class="banner-image">
            <img :src="bannerImage" alt="팝업 배너" />
          </div>

          <!-- 하단 버튼 -->
          <div class="popup-footer">
            <button class="btn-today-close" @click="closePopup">
              오늘 하루 보지 않기
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "PopupBanner",
  data() {
    return {
      showPopup: false,
      bannerImage: require('@/assets/images/popupBanner/1.png'),
      storageKey: 'popupBannerClosedDate',
      hideDays: 3 // 3일 동안 숨김
    }
  },
  mounted() {
    this.checkPopupState();
  },
  methods: {
    checkPopupState() {
      const closedDate = localStorage.getItem(this.storageKey);

      if (closedDate) {
        const closed = new Date(closedDate);
        const now = new Date();
        const diffTime = Math.abs(now - closed);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        // 3일이 지나지 않았으면 팝업 표시 안함
        if (diffDays < this.hideDays) {
          this.showPopup = false;
          return;
        }
      }

      // 3일이 지났거나 처음 방문한 경우 팝업 표시
      this.showPopup = true;
    },
    closePopup() {
      // 현재 날짜를 로컬스토리지에 저장
      const now = new Date();
      localStorage.setItem(this.storageKey, now.toISOString());
      this.showPopup = false;
    }
  }
}
</script>

<style scoped>
/* 오버레이 */
.popup-banner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 50px;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

/* 팝업 컨테이너 */
.popup-banner-container {
  position: relative;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  max-width: 90%;
  max-height: 90vh;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideDown 0.4s ease;
}

/* 닫기 버튼 */
.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  color: white;
  font-size: 20px;
  z-index: 10;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: rotate(90deg) scale(1.1);
}

/* 배너 이미지 */
.banner-image {
  max-width: 400px;
  max-height: calc(70vh - 80px);
  overflow: hidden;
  background: #5f74a9;
}

.banner-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 하단 버튼 */
.popup-footer {
  padding: 15px;
  background: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e0e0e0;
}

.btn-today-close {
  padding: 10px 25px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-today-close:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* 애니메이션 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 트랜지션 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 반응형 */
@media (max-width: 768px) {
  .popup-banner-container {
    max-width: 95%;
    max-height: 85vh;
  }

  .banner-image {
    max-width: 100%;
    max-height: calc(85vh - 80px);
  }

  .close-btn {
    width: 35px;
    height: 35px;
    font-size: 18px;
    top: 10px;
    right: 10px;
  }

  .popup-footer {
    padding: 12px;
  }

  .btn-today-close {
    padding: 8px 20px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .popup-banner-container {
    max-width: 98%;
    border-radius: 10px;
  }

  .banner-image {
    max-height: calc(85vh - 70px);
  }

  .close-btn {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
}
</style>
